export default {
  Billing: {
    TRIAL_NOTICE: [
      'Today is the last day of your trial.',
      'Your trial runs out in {{count}} days.',
    ],
    TRIAL_ENDED_NOTICE: 'Your trial has expired.',
    TRIAL_BUTTON: 'Upgrade now',
    TRIAL_PAST_DUE_NOTICE: 'Your subscription is past due.',
    TRIAL_PAUSED_NOTICE: 'Your subscription is paused.',
    SUBSCRIPTION_CANCELLING:
      'Your subscription has been cancelled and will end on {{cancellationDate}}.',
    UPDATE_SUBSCRIPTION: 'Update your subscription details here',
    UPGRADE_CALCS: 'Upgrade to run more than one calculation',
    Limits: {
      APPROACHING_LIMIT: [
        'You only have {{count}} transaction remaining for {{month}}.',
        'You only have {{count}} transactions remaining for {{month}}.',
      ],
      APPROACHING_RULES_LIMIT: [
        'You only have {{remaining}} rule remaining.',
        'You only have {{remaining}} rules remaining.',
      ],
      LIMITED: "You've used up your monthly transaction allowance.",
      RULE_LIMITED: "You've used your rule allowance.",
    },
    ANNUAL: 'Annual',
    MONTHLY: 'Monthly',
    PER_MONTH: '/ mo',
    PER_YEAR: '/ yr',
    Page: {
      TITLE: 'Billing',
      TRIAL_NOTICE:
        'Your trial has {{num}} days remaining. Upgrade using one of the options below',
      USAGE: [
        'Current usage: {{numEntities}} entity',
        'Current usage: {{numEntities}} entities',
      ],
      CHOOSE_CURRENCY: 'Choose billing currency:',
      BILLING_FREQUENCY: 'Billing frequency:',
      CURRENT_SUBSCRIPTION: 'Current subscription:',
      CURRENT_SUBSCRIPTION_CANCELLING:
        'Current subscription **(will be cancelled on {{cancellationDate}})**:',
      Plans: {
        PER_MONTH: 'per month',
        PER_YEAR: 'per year',
        USAGE: ['For {{numEntities}} entity', 'For {{numEntities}} entities'],
        BILLED_ANNUAL: 'Billed annually',
        BILLED_MONTHLY: 'Billed monthly',
        SELECT: 'Choose this plan',
        UPGRADE: 'Upgrade to {{plan}}',
        DOWNGRADE: 'Downgrade to {{plan}}',
        CURRENT: 'Current plan',
        CANCEL: 'Cancel subscription',
        UPDATE: 'Update subscription',
        UPDATE_BILLING: 'Update billing details',
        CHANGE_PLAN: 'Change plan',
        CHANGE_ADDONS: 'Adjust Add-ons',
        SWITCH: 'Switch to {{frequency}} billing',
        EQUIVALENT: 'Equivalent to {{number}} per month',
        RECHARGER_ADDONS: 'Add-on: **{{count}}** rules',
        RECHARGER_ADDONS_USED: 'Used: **{{count}}** rules',
        BRAG_ADDONS: 'Add-on: **{{count}}** transactions',
        BRAG_ADDONS_CARRIED_OVER: '(+{{count}} carried over)',
        BRAG_ADDONS_CARRIED_OVER_TOOLTIP:
          'Unused transactions from last month, carried over to this month',
        BRAG_ADDONS_USED: [
          'Used: **{{count}}** transaction',
          'Used: **{{count}}** transactions',
        ],
        SALES_TAX: '*Price excludes any applicable sales tax',
      },
      Payments: {
        TITLE: 'Payment History',
        NIL: 'A zero charge is sometimes made when your subscription is updated. If the cost of your subscription has reduced, the difference will be used as credit against the next payment',
      },
    },
    ChangePlan: {
      TITLE: 'Change your subscription plan',
    },
    ChangeAddons: {
      TITLE: 'Change your subscription add-ons',
      CURRENT_PRICE: 'Current add-on price:',
      NEW_PRICE: 'Updated add-on price:',
    },
    SelectAddons: {
      TITLE: 'Select optional add-ons:',
      CONFIRM_AND_PAY: 'Continue to payment',
    },
    Plans: {
      free: {
        NAME: 'Free',
        DESCRIPTION: 'Spot discrepancies in your intercompany balances',
        Features: {
          1: 'Balancer Transaction Matching',
          TOOLTIP_1:
            'Get access to the balancer dashboard and transaction history to help you spot posting asymmetries and calculate FX adjustments',
          2: 'Unlimited Users',
          3: 'Unlimited Support',
        },
      },
      lite: {
        NAME: 'Lite',
        DESCRIPTION:
          'For businesses with few intercompany transactions or who only need Balancer.',
        Features: {
          1: '**{{count}}** Recharger or BRAG Transactions /mo',
          TOOLTIP_1:
            'These can be used to either reconcile bank transactions across the group using BRAG, or to post intercompany recharges through Recharger. A combination of Recharger & BRAG transactions can be used.',
          2: 'All Balancer Features',
          3: 'Unlimited Users',
          4: 'Unlimited Support',
        },
      },
      full: {
        NAME: 'Full',
        DESCRIPTION: 'For businesses with material intercompany transactions.',
        Features: {
          1: '**Unlimited** Recharger Transactions',
          2: '**Unlimited** BRAG Transactions',
          3: 'All Balancer Features',
          4: 'Unlimited Users',
          5: 'Unlimited Support',
        },
      },
      old: {
        Features: {
          1: 'Unlimited entities',
          2: 'Unlimited calculations',
          3: 'Unlimited teammates',
          4: 'Unlimited support',
        },
      },
      202310: {
        lite: {
          Features: {
            1: '**{{count}}** BRAG Transactions /mo',
            TOOLTIP_1:
              'These can be used to reconcile bank transactions across the group using BRAG.',
            2: '**3** Recharge Rules',
            3: 'All Balancer Features',
            4: 'Unlimited Users',
            5: 'Unlimited Support',
          },
        },
        full: {
          Features: {
            1: '**Unlimited** Recharge rules',
          },
        },
      },
      202406: {
        free: {
          NAME: 'Free',
          DESCRIPTION: 'Spot discrepancies in your intercompany balances',
          BALANCER_FEATURES: {
            1: '**3** intercompany balances (same currency)',
          },
          RECHARGER_HEADER: 'Not included',
          BRAG_HEADER: 'Not included',
          PLATFORM: {
            1: 'Unlimited users',
            2: 'Access to support library',
            3: 'Support (via live chat)',
          },
        },
        passive: {
          NAME: 'Passive',
          DESCRIPTION: 'For businesses with few intercompany transactions',
          BALANCER_FEATURES: {
            1: '**Unlimited** intercompany balances',
            2: 'FX adjustments',
            3: 'Interest',
            4: 'Downloadable reports',
            5: 'Fix asymmetries',
          },
          RECHARGER_HEADER: 'Available as an add-on',
          BRAG_HEADER: 'Available as an add-on',
          PLATFORM: {
            1: 'Unlimited users',
            2: '1-hour tailored onboarding',
            3: 'Support (via live chat)',
          },
        },
        active: {
          NAME: 'Active',
          DESCRIPTION: 'For businesses with material intercompany transactions',
          BALANCER_HEADER: 'Everything from **Passive**, plus:',
          BALANCER_FEATURES: {
            1: 'AR/AP based balances',
          },
          RECHARGER_FEATURES: {
            1: '**Unlimited** rules',
            2: 'Post as Invoice/Bill',
            3: 'Custom recharge periods',
            4: 'Post by transaction or rule',
          },
          BRAG_FEATURES: {
            1: '**Unlimited** transactions',
          },
          PLATFORM: {
            1: 'Unlimited users',
            2: '1-hour tailored onboarding',
            3: 'Support (via live chat)',
          },
        },
        advanced: {
          NAME: 'Advanced',
          DESCRIPTION: 'For complex groups with more bespoke needs',
          BALANCER_HEADER: 'Everything from **Active**',
          RECHARGER_HEADER: 'Everything from **Active**, plus:',
          RECHARGER_FEATURES: {
            1: 'Bespoke rule creation service',
          },
          BRAG_FEATURES: {
            1: '**Unlimited** transactions',
          },
          PLATFORM: {
            1: 'Unlimited users',
            2: '2-hour tailored onboarding',
            3: 'Support (via live chat and Zoom)',
            4: 'Guided setups',
            5: 'Dedicated account manager',
          },
        },
        full: {
          NAME: 'Full',
          DESCRIPTION:
            'For businesses with material inter-departmental transactions',
          RECHARGER_FEATURES: {
            1: 'Unlimited rules',
          },
        },
        lite: {
          NAME: 'Lite',
          DESCRIPTION:
            'For businesses with few inter-departmental transactions',
          RECHARGER_FEATURES: {
            1: '3 rules',
          },
        },
      },
    },
    Notices: {
      PlanUpdated: {
        TITLE: 'Thanks!',
        BODY: "We've moved you from the {{oldPlan}} plan to {{newPlan}}, with {{newFreq}} billing. You should receive a receipt for the transaction in the next few minutes.",
      },
      PlanUpdateFailed: {
        TITLE: 'Issue updating plan',
        BODY: "There's been an issue updating your plan. Please try again or contact support via the live chat in the bottom-right corner.",
      },
      CycleUpdated: {
        TITLE: 'Thanks!',
        BODY: "We've moved you from {{oldFreq}} billing to {{newFreq}}. You should receive a receipt for the transaction in the next few minutes.",
      },
      AddonsUpdated: {
        TITLE: 'Thanks!',
        BODY: 'We have adjusted your add-ons. You should receive a receipt for the transaction in the next few minutes. The page will now auto-refresh to reflect your new subscription.',
      },
      AddonsUpdateFailed: {
        TITLE: 'Issue updating add-ons',
        BODY: "There's been an issue updating your add-ons. Please try again or contact support via the live chat in the bottom-right corner.",
      },
    },
  },
};
